import inflationBook from 'assets/images/inflationBook.png';
import inflationBookOverview from 'assets/images/booksOverview/inflationBook.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const inflation = {
  book: {
    id: 'inflation',
    format: FLIP_BOOKS,
    title: 'Die Inflation ist zurück',
    subtitle: 'Was heisst das',
    videos: 'Erwin Heri and Alexandra Janssen',
    layoutAndProduction: 'Eric Marschall and Hanspeter Frey',
    scope: { pages: 20, videos: 19 },
    price: [0, 18],
    introductions: ['Introduction Inflation'],
    image: inflationBook,
    overviewImg: inflationBookOverview,
  },
  bookIds: [13, 14],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([0, 18], [14, 13]),
};

export default inflation;
